import { gql, TypedDocumentNode } from '@apollo/client';

import type {
  RecordConsentPreferenceEventMutation,
  RecordConsentPreferenceEventMutationVariables,
} from '@/api/gql/graphql';

export const RECORD_CONSENT_PREFERENCE_EVENT: TypedDocumentNode<
  RecordConsentPreferenceEventMutation,
  RecordConsentPreferenceEventMutationVariables
> = gql`
  mutation recordConsentPreferenceEvent($input: ConsentPreferenceEventInput!) {
    data: recordConsentPreferenceEvent(input: $input) {
      eventId
      error {
        code
        message
      }
    }
  }
`;
